module.exports = __webpack_public_path__ + "img/partnerPc.3e9afc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partnerPc.png
// module id = Fpqy
// module chunks = 0